import MigrationTable from './MigrationTable';
import  { useState } from "react";
import CreateModels from './CreateModels';
import LogModels from './LogModel';
import ViewConversation from './ViewConversation';
import Edit from './Edit';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

function Migration({isGithubConfigured }) {
  const location = useLocation();
  const [showEdit, setShowEdit] = useState(false);
  const [logshow, logsetShow] = useState(false);
  const [conshow, consetShow] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [selectedFileId, setSelectedFileId] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedFilename, setselectedFilename] = useState(null);
  const [selectedJobname, setselectedJobname] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [show, setShow] = useState(false);
  const [executingJobs, setExecutingJobs] = useState([]);
  const [SelectedFileStatus,setSelectedFileStatus]=useState([]);
  const [newlyCreatedJob, setNewlyCreatedJob] = useState(null);
  const [pendingJobPreview, setPendingJobPreview] = useState(null);

  const isDeletedView = location.pathname === '/migration/deleted_jobs';
  const IsDraftView = location.pathname === '/migration/draft_jobs'; // Add this line

  useEffect(() => {
    if (location.state?.openCreateModal) {
      setShow(true);
      setCurrentStep(1);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const handleJobSaved = () => {
    setRefreshKey(prev => prev + 1);
  };

    const handleJobExecuted = (jobId, previewOrError) => {
    if (jobId) {
      if (previewOrError === "error") {
        // Execution failed to start - drop the optimistic row we added.
        setExecutingJobs(prev => prev.filter(id => id !== jobId));
        setPendingJobPreview({ job_id: jobId, __remove: true });
      } else {
        setExecutingJobs(prev => [...prev, jobId]);
        setNewlyCreatedJob(jobId);
        // Clear after 4 seconds
        setTimeout(() => setNewlyCreatedJob(null), 4000);
        if (previewOrError && typeof previewOrError === "object") {
          setPendingJobPreview(previewOrError);
        }
      }
    }
    setRefreshKey(prev => prev + 1);
  };
  return (
    <div className="tab_content">
      <div className="page-content">
        <div className="container-fluid">
          <MigrationTable
            isDeletedView={isDeletedView}
            logsetShow={logsetShow}
            consetShow={consetShow}
            setSelectedJobId={setSelectedJobId}
            setselectedJobname={setselectedJobname}
            setselectedFilename={setselectedFilename}
            setSelectedFileId={setSelectedFileId}
            setSelectedFileStatus={setSelectedFileStatus}
            setShowEdit={setShowEdit}
            onEditJob={setSelectedJob}
            refreshKey={refreshKey}
            setShow={setShow}
            setCurrentStep={setCurrentStep}
            setRefreshKey={setRefreshKey}
            executingJobs={executingJobs}
            setExecutingJobs={setExecutingJobs}
            IsDraftView={IsDraftView}
             newlyCreatedJob={newlyCreatedJob}
             pendingJobPreview={pendingJobPreview}
              isGithubConfigured={isGithubConfigured}
           
 
          />
        </div>
      </div>

      <div className={`rightbar-overlay ${logshow || conshow || show || showEdit ? "d-block" : "d-none"}`}></div>

      {!isDeletedView && (
        <>
          <CreateModels
            show={show}
            setShow={setShow}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            onJobExecuted={handleJobExecuted}
          />

          <Edit
            show={showEdit}
            setShow={setShowEdit}
            job={selectedJob}
            onSave={handleJobSaved}
             apiEndpoint={`${process.env.REACT_APP_API_URL_CODE_CONVERSION}/edit_job`}
          />
        </>
      )}

      {logshow && (
        <LogModels
          logshow={logshow}
          logsetShow={logsetShow}
          jobId={selectedJobId}
          fileId={selectedFileId}
          jobName={selectedJobname}
          fileName={selectedFilename}
        />
      )}

      {conshow && (
        <ViewConversation
          conshow={conshow}
          consetShow={consetShow}
          jobId={selectedJobId}
          fileId={selectedFileId}
          jobName={selectedJobname}
          fileName={selectedFilename}
          fileStatus={SelectedFileStatus}
        />
      )}
    </div>
  );
}

export default Migration;